/* "Scegli il tuo mazzo" — le carte seguono la palette scelta nell'arco.

   L'arco annuncia la scelta con l'evento 'mismazzo:palette'; qui ci si accoda.
   Non c'e' nessun legame diretto fra le due sezioni: se l'arco non c'e' in
   pagina, non succede niente e le carte restano quelle del Liquid.

   Sul peso: questo file e' l'unica aggiunta al caricamento (poco piu' di 1 KB).
   Le immagini delle altre palette si scaricano SOLO se qualcuno preme una
   pastiglia, e sono le stesse dell'arco, quindi spesso gia' in cache.

   Le Napoletane non sono disegnate in tutte le palette (in palette 3 manca il
   re). Non c'e' un elenco di cosa manca: si prova, e se l'immagine non arriva
   si torna a quella di partenza. Cosi' il codice non va aggiornato quando le
   carte mancanti verranno disegnate. */
(function () {
  var RIPIEGO = 'palette-1';

  function via(img, palette) {
    var base = img.dataset.base;
    var mazzo = img.dataset.mazzo;
    var nome = img.dataset.nome;
    if (img.dataset.sorgente === 'shopify') {
      return base + 'carta-' + mazzo + '-' + palette.replace('palette-', 'p') + '-' + nome + '.webp';
    }
    return base + mazzo + '/' + palette + '/' + nome + '.webp';
  }

  /* Si aspetta che la nuova sia decodificata prima di mostrarla: cambiando
     l'indirizzo e basta il browser butta subito la vecchia e lascia il vuoto
     finche' non ha finito. Stessa cura gia' adottata nell'arco. */
  function scambia(img, palette) {
    var indirizzo = via(img, palette);
    if (img.getAttribute('src') === indirizzo) return;
    var nuova = new Image();
    nuova.src = indirizzo;
    nuova.decode().then(function () {
      img.setAttribute('src', indirizzo);
    }).catch(function () {
      if (palette !== RIPIEGO) scambia(img, RIPIEGO);
    });
  }

  document.addEventListener('mismazzo:palette', function (e) {
    var palette = e.detail && e.detail.palette;
    if (!palette) return;
    document.querySelectorAll('.porta__carta[data-mazzo]').forEach(function (img) {
      scambia(img, palette);
    });
  });
})();
